<script setup>
const cms = useCms()
const common = cms.value?.common

const page = computed(() => cms.value?.page)

const globalModal = useGlobalModal()
globalModal.value['buttonOk'].text = common?.text_ok
const countryStore = useCountry()
const clientStore = useClientStore()
const currencyStore = useCurrencyStore()
const languageStore = useLanguage()
const loadingStore = useLoading()
const route = useRoute()
if (route?.name == 'detail') {
  loadingStore.value = true
}

const orderStore = useOrderData()
const checkoutStep = useState('checkoutStep', () => 'driver_info')
const { $analytics } = useNuxtApp()
const screenType = useScreenType()

const allowFields = ref({
  individual: [
    'firstName',
    'lastName',
    'zipCode',
    'country',
    'adm1',
    'adm2',
    'line',
    'label'
  ],
  corporateCompany: [
    'firstName',
    'lastName',
    'zipCode',
    'country',
    'adm1',
    'adm2',
    'line',
    'taxDivision',
    'taxIdentifier',
    'label'
  ]
})

const agreementForm = useState('agreementForm')
const driverForm = useState('driverForm')
const billingForm = useState('billingForm')
const paymentForm = useState('paymentForm')
const paymentDetail = ref()

const paymentPriceRequirement = useState('paymentPriceRequirement')

const locationStore = useLocation()

const priceInfo = computed(() => {
  const productDetail = clientStore.value?.carDetail

  locationStore.value = {
    pickup: {
      ...locationStore.value?.pickup,
      checkInDateTime: productDetail?.details?.car?.appointment?.checkInDateTime
      // long_name: productDetail?.details?.car?.appointment?.checkInOffice?.address?.adm2
    },
    dropoff: {
      ...locationStore.value?.dropoff,
      checkOutDateTime:
        productDetail?.details?.car?.appointment?.checkOutDateTime
      // long_name: productDetail?.details?.car?.appointment?.checkOutOffice?.address?.adm2
    }
  }

  const extraProducts = productDetail?.extraProducts

  let cardPayExtraProducts = []
  let officePayExtraProducts = []

  extraProducts?.forEach(x => {
    let cardPayExtra = x?.pricing?.display?.paymentTotal?.children?.map(y => {
      return {
        ...y,
        quantity: x?.quantity,
        productType: x?.type,
        cmsKey: x?.cmsKey
      }
    })
    let officePayExtra = x?.pricing?.display?.vendorTotal?.children?.map(y => {
      return {
        ...y,
        quantity: x?.quantity,
        productType: x?.type,
        cmsKey: x?.cmsKey
      }
    })
    cardPayExtraProducts = [...cardPayExtraProducts, ...(cardPayExtra || [])]
    officePayExtraProducts = [
      ...officePayExtraProducts,
      ...(officePayExtra || [])
    ]
  })

  const cardPay = [
    ...(productDetail?.pricing?.display?.paymentTotal?.children || []),
    ...(cardPayExtraProducts || [])
  ]
  const officePay = [
    ...(productDetail?.pricing?.display?.vendorTotal?.children || []),
    ...(officePayExtraProducts || [])
  ]

  // const discount = productDetail?.pricing?.find(
  //   x => x.type == 'discount'
  // )

  const paymentInfo = orderStore.value?.pricing?.total

  return {
    officePay,
    cardPay,
    paymentInfo,
    totalCardPay: cardPay?.reduce((acc, item) => {
      return acc + item?.amount?.amount * (item?.quantity || 1)
    }, 0),
    totalOfficePay: officePay?.reduce((acc, item) => {
      return acc + item?.amount?.amount * (item?.quantity || 1)
    }, 0),
    currency: productDetail?.pricing?.display?.currency,
    sitePrice: productDetail?.pricing?.display?.fee,
    totalDays: productDetail?.period?.amount || 1,
    checkInOffice: productDetail?.details?.car?.appointment?.checkInOffice,
    checkInDateTime: productDetail?.details?.car?.appointment?.checkInDateTime,
    checkOutDateTime:
      productDetail?.details?.car?.appointment?.checkOutDateTime,
    checkOutOffice: productDetail?.details?.car?.appointment?.checkOutOffice,
    includedCoverages: productDetail?.details?.car?.includedCoverages
  }
})

const modalCheckout = useState('modalCheckout')

watchDebounced(
  () => paymentForm.value?.cardNumber?.value,
  async (newValue, oldValue) => {
    let cardNumber = newValue?.replaceAll(' ', '')

    if (cardNumber?.length > 8) {
      const result = await useApi({
        endpoint: '/api/v1/payment-api/payments/info',
        options: {
          body: {
            binNumber: cardNumber,
            superAppPart: 'bookcars',
            price: paymentPriceRequirement.value,
            locale: languageStore.value
          }
        }
      })
      if (result) {
        // installments.value = result?.installmentPrices
        agreementForm.value['is3DSecure']['value'] = result?.shouldForceTo3D
        agreementForm.value['shouldForceTo3D']['value'] =
          result?.shouldForceTo3D

        const isCurrencySupport = result?.supportedCurrencies?.indexOf(
          currencyStore.value
        )
        if (isCurrencySupport < 0) {
          globalModal.value['type'] = 'info'
          globalModal.value['description'] = usePluralization(
            common?.error_modal_currency_description,
            {
              value: result?.supportedCurrencies?.join(',')
            }
          )

          globalModal.value['title'] = common?.[`error_modal_currency_title`]
          globalModal.value['buttonOk'].func = async () => {
            paymentForm.value['cardNumber'].value = {
              value: '',
              label: page.value?.label_cardNumber,
              placeholder: page.value?.placeholder_cardNumber
            }

            await navigateTo({
              path: `/${languageStore.value}/detail`,
              force: true,
              query: {
                code: clientStore.value?.carDetail?.code,
                searchId: clientStore.value?.carDetail?.searchID
              }
            })
          }
        }
      }
    }
  },
  { debounce: 500, maxWait: 1000 }
)

async function goToCheckout() {
  await navigateTo({
    path: `/${languageStore.value}/checkout`
    // query: {
    //   ...route.query
    // }
  })
}

async function addItemToOrder() {
  loadingStore.value = true
  const result = await useOrderApi({
    type: 'car_item',
    children: clientStore.value['carDetail']?.extraProducts?.map(x => {
      return {
        searchID: x?.searchID,
        code: x?.code,
        quantity: x?.quantity
      }
    })
  })
  loadingStore.value = false

  if (!result?.error) {
    // const totalAmount =
    //   result?.product?.amount +
    //   result?.children?.reduce((acc, item) => {
    //     return acc + item?.amount
    //   }, 0)

    // if (
    //   totalAmount !=
    //   priceInfo.value?.totalCardPay + priceInfo.value?.totalOfficePay
    // ) {
    //   modal['type'] = 'price_change'
    // } else {
    //   await goToCheckout()
    // }
    await goToCheckout()
  } else {
    errorModal(result?.error?.message)
  }
}

async function payReservation() {
  loadingStore.value = true

  if (paymentPriceRequirement.value) {
    let reqBody = {
      with: 'card',
      locale: languageStore.value,
      price: paymentPriceRequirement.value
    }

    let carProduct = orderStore.value?.items?.find(x => x?.status == 'pending')

    const callbackUrl = `${location?.origin}/${languageStore.value}/checkout/control?itemId=${carProduct?.id}`

    const cardExpire = paymentForm.value?.expiresAt?.value?.split('/')
    const cardNumber = paymentForm.value?.cardNumber?.value?.replaceAll(' ', '')
    reqBody['paymentCard'] = {
      cardNumber: cardNumber,
      expireMonth: cardExpire?.[0],
      expireYear: cardExpire?.[1],
      cardHolderName: paymentForm.value?.cardHolder?.value,
      cvc: paymentForm.value?.cvc?.value
    }

    reqBody['callbackURL'] = callbackUrl
    reqBody['installment'] = 1
    reqBody['isWith3DSecure'] = agreementForm.value?.is3DSecure?.value
    reqBody['itemIds'] = clientStore.value?.carDetail?.itemIds

    const result = await useApi({
      endpoint: '/api/v1/payment-api/payments/charge',
      params: orderStore.value?.paymentId || paymentDetail.value?.id,
      options: {
        body: reqBody
      }
    })

    if (!result?.error) {
      await chargeResult(result)
    } else {
      errorModal(result?.error?.message || result?.error)
    }
  }

  loadingStore.value = false
}

async function chargeResult(result) {
  if (agreementForm.value?.is3DSecure?.value) {
    modalCheckout.value['type'] = 'html_content'
    console.log(result?.htmlContent)
    modalCheckout.value['srcDoc'] = atob(result?.htmlContent)
  } else if (result?.status == 'Success') {
    await completeOrder(result)
  }
}

async function completeOrder() {
  let carProduct = orderStore.value?.items?.find(x => x?.status == 'pending')
  const orderId = orderStore.value?.id
  const itemId = carProduct?.id
  const result = await useApi({
    endpoint: '/api/v1/order-api/order/reserve/',
    params: {
      orderId,
      itemId
    },
    options: {
      server: false
    }
  })

  if (!result?.error) {
    if (result?.status == 'reserved') {
      useOrderApi({ type: 'remove' })
      await navigateTo({
        path: `/${languageStore.value}/reservation`,
        query: {
          orderId,
          itemId
        }
      })
    }
  } else {
    errorModal(result?.error?.message)
  }
}

function convertDate(date) {
  const splitDate = date.split('/')
  if (
    splitDate?.[0]?.length != 2 ||
    splitDate?.[1]?.length != 2 ||
    splitDate?.[2]?.length != 4
  ) {
    return null
  }
  return `${splitDate[1]}/${splitDate[0]}/${splitDate[2]}`
}

async function validateForms() {
  if (checkoutStep.value == 'driver_info') {
    const billingType = billingForm.value['type']?.['value']?.value

    Object.entries(billingForm.value || {}).forEach(([key, value]) => {
      if (allowFields.value[billingType].includes(key)) {
        if (!value.value) {
          value.message = common?.error_input_required
          value.error = 'red'
        } else {
          value.message = ''
          value.error = ''
        }
      }
    })

    Object.entries(driverForm.value || {}).forEach(([key, value]) => {
      if (key == 'passportNo') return
      if (key == 'birthDate') {
        if (!value.value) {
          value.message = common?.error_input_required
          value.error = 'red'
        } else {
          const convertDateValue = convertDate(value?.value)

          if (!convertDateValue) {
            value.message = common?.error_input_required
            value.error = 'red'
          } else {
            const birthDate = new Date(
              useDate({
                date: convertDateValue,
                format: 'YYYY-MM-DD'
              })
            )
            const currentDate = new Date(
              useDate({
                date: new Date(),
                format: 'YYYY-MM-DD'
              })
            )
            const age = (currentDate - birthDate) / (1000 * 60 * 60 * 24)
            const age18 = 6570
            const minAgeYear =
              clientStore.value?.carDetail?.details?.car?.rules?.find(
                x => x?.type == 'minDriverAge'
              )?.details?.minDriverAge
            const minAgeDay = minAgeYear * 365
            if (age < age18) {
              value.message = common[`error_input_${key}`]
              value.error = 'red'
            } else if (age < minAgeDay) {
              globalModal.value['type'] = 'error'
              globalModal.value['description'] =
                common?.[`error_modal_minDriverAge_description`]
              globalModal.value['title'] =
                common?.[`error_modal_minDriverAge_title`]
              value.error = 'red'
            } else {
              value.message = ''
              value.error = ''
            }
          }
        }
      } else if (key == 'phone') {
        if (!value.value.number) {
          value.message = common?.error_input_required
          value.error = 'red'
        } else {
          value.message = ''
          value.error = ''
        }
      } else if (!value.value) {
        value.message = common?.error_input_required
        value.error = 'red'
      } else {
        value.message = ''
        value.error = ''
      }
    })

    const isAgreement = agreementForm.value['isAgreement']['value']

    if (!isAgreement) {
      agreementForm.value['isAgreement']['error'] = 'red'
      agreementForm.value['isAgreement']['message'] =
        page.value?.checkout_agreement_error
    } else {
      agreementForm.value['isAgreement']['error'] = ''
      agreementForm.value['isAgreement']['message'] = ''
    }

    const isExistErrorDriver = Object.values(driverForm.value).some(
      x => x.error
    )
    const isExistErrorBilling = Object.values(billingForm.value).some(
      x => x.error
    )

    if (isExistErrorDriver || isExistErrorBilling || !isAgreement) return false

    return true
  } else {
    Object.entries(paymentForm.value || {}).forEach(([key, value]) => {
      if (!value.value) {
        value.message = common?.error_input_required
        value.error = 'red'
      } else {
        value.message = ''
        value.error = ''
      }
    })

    Object.entries(agreementForm.value || {}).forEach(([key, value]) => {
      if (key == 'isAgreementVendor' || key == 'isOwnCreditCard') {
        if (!value.value) {
          value.message = common?.error_input_required
          value.error = 'red'
        } else {
          value.message = ''
          value.error = ''
        }
      }
    })
    const isAgreementVendor = agreementForm.value['isAgreementVendor']['value']
    const isOwnCreditCard = agreementForm.value['isOwnCreditCard']['value']

    const isExistErrorPayment = Object.values(paymentForm.value).some(
      x => x.error
    )

    if (isExistErrorPayment || !isAgreementVendor || !isOwnCreditCard)
      return false

    return true
  }
}

const carData = computed(() => {
  const car = clientStore.value?.carDetail

  return {
    title: `${car?.details?.car?.brand?.name} ${car?.details?.car?.model?.name}`,
    image: car?.details?.car?.images?.find(x => x?.size == screenType.value)
      ?.url,
    vendor: car?.details?.car?.vendor,
    fuel: car?.details?.car?.fuel,
    transmission: car?.details?.car?.transmission,
    rangeLimit: car?.details?.car?.rules?.find(x => x?.type == 'rangeLimit')
      ?.details?.rangeLimit,
    deposit: car?.details?.car?.rules?.find(x => x?.type == 'deposit')?.details
      ?.deposit,
    driver_lisence_age: car?.details?.car?.rules?.find(
      x => x?.type == 'minLicenseYear'
    )?.details?.minLicenseYear,
    min_driver_age: car?.details?.car?.rules?.find(
      x => x?.type == 'minDriverAge'
    )?.details?.minDriverAge,
    checkInOffice: car?.details?.car?.appointment?.checkInOffice
  }
})

async function onSubmit() {
  loadingStore.value = true
  if (route?.name == 'detail') {
    await addItemToOrder()

    $analytics.productContinue({
      car_brand: carData.value?.title,
      vendor: carData.value?.vendor?.name,
      fuel: carData.value?.fuel?.name,
      transmission: carData.value?.transmission?.name,
      deposit: carData.value?.deposit?.amount,
      km_limit: carData.value?.rangeLimit?.amount,
      driver_lisence_age: carData.value?.driver_lisence_age,
      min_driver_age: carData.value?.min_driver_age,
      distance: (
        getDistanceFromLatLonInKm(
          route?.query?.p_p?.split(',')?.[0],
          route?.query?.p_p?.split(',')?.[1],
          carData.value?.checkInOffice?.coordinates?.lat,
          carData.value?.checkInOffice?.coordinates?.lon
        ) * 1000
      ).toFixed(1)
    })
  } else if (route?.name == 'checkout') {
    if (await validateForms()) {
      if (checkoutStep.value == 'driver_info') {
        const isSuccess = await updateDriverInfo()
        if (isSuccess) {
          checkoutStep.value = 'payment_info'
        }
      } else {
        await payReservation()
      }
    }
  }
  loadingStore.value = false
}

async function updateDriverInfo() {
  const orderId = orderStore.value?.id

  // console.log(driverForm.value?.['birthDate']?.value)

  // let birthDate = useDate({
  //   date: convertDate(driverForm.value?.['birthDate']?.value),
  //   format: 'YYYY-MM-DD'
  // })

  // console.log('birthDate', birthDate)
  // if (birthDate.includes('NaN')) {
  //   birthDate = useDate({
  //     date: convertDate(driverForm.value?.['birthDate']?.value),
  //     format: 'YYYY-MM-DD'
  //   })
  // }

  const passengerData = await useApi({
    endpoint: '/api/v1/order-api/order/passenger/',
    params: orderId,
    options: {
      body: {
        firstName: driverForm.value?.['firstName']?.value,
        lastName: driverForm.value?.['lastName']?.value,
        email: driverForm.value?.['email']?.value,
        phone: {
          cc: driverForm.value?.['phone']?.value?.cc,
          number: driverForm.value?.['phone']?.value?.number?.replace(/\D/g, '')
        },
        nationality: countryStore.value,
        passportNo: driverForm.value?.['passportNo']?.value || 'dsaasd',
        birthDate: '1990-02-03'
      },
      server: false
    }
  })

  const billingType = billingForm.value['type']?.['value']?.value

  let billingBody = {
    type: billingType,
    language: languageStore.value
  }
  Object.entries(billingForm.value).forEach(([key, value]) => {
    if (allowFields.value[billingType].includes(key)) {
      if (key == 'type') return
      if (key == 'country') {
        billingBody['countryCode'] = value?.value?.value
        billingBody['countryName'] = value?.value?.text
      } else {
        billingBody[key] = value?.value
      }
    }
  })

  const billingData = await useApi({
    endpoint: '/api/v1/order-api/order/billing/',
    params: orderId,
    options: {
      body: {
        ...billingBody
        // registeredAddressID: billingForm.value?.id,
      },
      server: false
    }
  })

  const paymentResult = await getPaymentDetail(orderId)
  paymentDetail.value = paymentResult

  if (!passengerData?.error && !billingData?.error) {
    orderStore.value = {
      ...orderStore.value,
      passenger: passengerData,
      billing: billingData
    }
    return true
  }
  const passengerError =
    common?.[`error_code_${passengerData?.error?.code}`] ||
    passengerData?.error?.message
  const billingError =
    common?.[`error_code_${billingData?.error?.code}`] ||
    billingData?.error?.message
  errorModal(passengerError || billingError)

  return false
}

async function getRequirement(orderId) {
  const result = await useApi({
    endpoint: '/api/v1/order-api/order/payment/requirement/',
    params: orderId,
    options: {
      server: false
    }
  })

  if (!result?.error) {
    paymentPriceRequirement.value = result
  }
}
async function getPaymentDetail(orderId) {
  const result = await useApi({
    endpoint: '/api/v1/order-api/order/payment/',
    params: orderId,
    options: {
      server: false
    }
  })

  if (result) {
    getRequirement(orderId)
    return result
  }
}

function errorModal(message) {
  globalModal.value['type'] = 'error'
  globalModal.value['description'] = message
  globalModal.value['buttonOk'].func = () => {}
}

async function handleButton(type, func) {
  globalModal.value['type'] = null

  if (func) await func()
}
</script>

<template>
  <div class="h-max flex flex-col justify-between">
    <LoadingCircle :modelValue="loadingStore" />
    <Header :is-scrolled="true" />
    <SearchStickyHeader />

    <div class="bg-ui-colourful-100 h-full">
      <HeaderCheckout v-if="clientStore"></HeaderCheckout>
      <div class="w-full px-4 mobile:px-0">
        <div
          class="max-w-[1440px] mx-auto pb-6 flex flex-col gap-x-4 desktop:flex-row mobile:px-3"
        >
          <div class="w-full">
            <div
              v-if="$route.name == 'checkout'"
              class="flex items-center gap-x-2 text-dark-gray bg-button-tertiary px-6 py-4 rounded-[10px] mb-4"
            >
              <i class="icon-danger text-main-secondary"></i>
              <div
                class="text-base font-bold"
                :cms-key="`checkout_title_${checkoutStep}`"
              >
                {{ page?.[`checkout_title_${checkoutStep}`] }}
              </div>
            </div>
            <slot />
          </div>

          <PriceBox
            :key="loadingStore"
            v-if="clientStore?.carDetail"
            :priceInfo="priceInfo"
            @submit="onSubmit"
          ></PriceBox>
        </div>
      </div>
    </div>

    <FooterGeneric v-if="!loadingStore" />

    <Modal :open="!!globalModal?.type">
      <div class="grid place-items-center h-full">
        <div class="max-w-[460px] bg-white rounded-[10px]">
          <div class="text-center p-10">
            <div class="grid place-content-center">
              <div
                class="rounded-full border-[8px] relative h-[64px] w-[64px] grid place-items-center"
                v-if="globalModal[globalModal?.type]?.icon"
                :class="`${globalModal[globalModal?.type]?.border2} `"
              >
                <div
                  :class="`${globalModal[globalModal?.type]?.border1} `"
                  class="rounded-full border-[6px] absolute h-[58px] w-[58px] grid place-items-center"
                >
                  <i
                    :class="`${globalModal[globalModal?.type]?.icon} ${
                      globalModal[globalModal?.type]?.iconColor
                    } text-[49px] absolute   -top-[12px] -left-[11px]  `"
                  ></i>
                </div>
              </div>
            </div>
            <div
              v-if="globalModal?.title"
              class="pt-[25px] font-normal text-[22px] text-[#171717]"
            >
              {{ globalModal?.title }}
            </div>
            <div
              v-if="globalModal?.description"
              class="pt-[10px] font-normal text-base text-[#454545]"
              v-html="globalModal?.description"
            ></div>
            <div class="flex gap-x-[30px] justify-center mt-[26px]">
              <Button
                class="w-full"
                v-if="globalModal?.buttonOk?.text"
                :size="globalModal?.buttonOk?.size"
                :color="globalModal?.buttonOk?.color"
                @click="
                  () => handleButton('buttonOk', globalModal?.buttonOk?.func)
                "
              >
                {{ globalModal?.buttonOk?.text }}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>
